import { GeoCountryEntity } from '../entities';
import { baseResource } from './Base';
export const GeoCountryResource = baseResource({
    path: '/geo/countries/:id',
    schema: GeoCountryEntity
});
